import * as React from "react";

import "./App.css";
import RightDrawer from "./components/nav/drawer/RightDrawer";
import i18ny from "./helpers/i18n";

import { SnackbarProvider } from "notistack";
import SnackBarTransaction from "./components/ui/SnackBarTransaction";
import StandardSnackBar from "./components/ui/StandardSnackBar";

import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";

import { useStoreDispatch, useStoreSelector } from "./store/Hooks";
import {
  authSliceActions,
  PostGrestToken,
  isValidPostgrestToken,
} from "./store/slices/AuthSlice";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { configure } from "@testing-library/react";
import RouterIndex from "./router";

import jwt_decode from "jwt-decode";
import { AlertColor } from "@mui/material/Alert";
import store from "./store/Store";
import { current } from "@reduxjs/toolkit";
import { interactionTreeSliceActions } from "./store/slices/InteractionTreeSlice";

configure({ asyncUtilTimeout: 60000 });

// This lets us customize what kinds of snackbars we allow
// Default from notistack is default, success, error, warning and info.

// Notistack doesn't use default mui alert colors for some reason
// So in the provider I've manually set up a StandardSnackBar
// StandardSnackBar lets us use mui's standard close button too
declare module "notistack" {
  interface VariantOverrides {
    transaction: {
      undoFunction: () => Promise<void>;
      severity?: AlertColor;
    };
  }
}

const redirect_to_login = () => {
  window.location.replace(
    process.env.REACT_APP_CARESENSE_URL + "/v2/interactionsEditor",
  );
  return <div>Redirecting to CareSense.com....</div>;
};

function App() {
  const [cookies] = useCookies(["postgrest"]);
  const dispatch = useStoreDispatch();
  // const isLoggedIn = useStoreSelector((state) => state.auth.isLoggedIn);
  const isLoggedIn =true;

  useEffect(() => {
    let redirect = false; // If we should redirect to login
    if (!isLoggedIn) {
      redirect = true; // We aren't logged in, default to redirecting unless cookies are valid
      const postgrestCookie = cookies.postgrest;

      if (postgrestCookie) {
        let decodedPostgrestCookie: null | PostGrestToken = null;
        try {
          decodedPostgrestCookie = jwt_decode(postgrestCookie);
          if (decodedPostgrestCookie === null) {
            throw new Error("Unable to decode cookie");
          }
          decodedPostgrestCookie.jwt = postgrestCookie;
        } catch (err: any) {
          /* empty */
        }

        if (isValidPostgrestToken(decodedPostgrestCookie)) {
          dispatch(authSliceActions.logIn(decodedPostgrestCookie));
          redirect = false; // User's credentials are good, no need to log in
        }
      }
    }
    if (redirect) {
      redirect_to_login();
    }
  }, [isLoggedIn, cookies]);

  //Check if cookies exist, if not immediately redirect
  if (!cookies.postgrest) {
    // return redirect_to_login();
  }

  return (
    <main>
      <DndProvider backend={HTML5Backend}>
        <SnackbarProvider
          autoHideDuration={5000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          variant="info"
          Components={{
            transaction: SnackBarTransaction,
            default: StandardSnackBar,
            success: StandardSnackBar,
            error: StandardSnackBar,
            warning: StandardSnackBar,
            info: StandardSnackBar,
          }}
        >
          <React.Suspense>
            {isLoggedIn && <RouterIndex />}
            <RightDrawer />
          </React.Suspense>
        </SnackbarProvider>
      </DndProvider>
    </main>
  );
}

export default App;
